import { useMutation } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import { CreativeImportValidationReport } from '@marketing-milk/interfaces'

/** Uploads the ZIP for synchronous validation. Read-only in S1 — nothing is created or persisted. */
export const useCreativeImportValidate = () => {
  const business = useGetBusiness()

  return useMutation(async (file: File): Promise<CreativeImportValidationReport> => {
    const formData = new FormData()
    formData.append('archive', file)
    const response = await NestAPI.post<CreativeImportValidationReport>(
      `businesses/${business.id}/creative-import/validate`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  })
}
